import { makeStyles } from '@fluentui/react-components';

import { palette, tokens } from '../../theme';

export type StatProps = {
    label: string;
    value: string;
};

export const Stat: React.FC<StatProps> = ({ label, value }) => {
    const classes = useStyles();
    return (
        <div className={classes.block}>
            <span className={classes.value}>{value}</span>
            <span className={classes.label}>{label}</span>
        </div>
    );
};

const useStyles = makeStyles({
    block: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        minWidth: 0,
    },
    value: {
        fontSize: '13px',
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
        lineHeight: 1.1,
    },
    label: {
        fontSize: '11.5px',
        color: palette.dimText,
    },
});
